import { Box, Flex, FormLabel, Link, Text } from '@chakra-ui/react'
import React from 'react'
import { useWatch } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import useFile from '@/features/files/useFile'

const SharepointFileList = ({ type, canUpload, label, ...rest }) => {
  const dispatch = useDispatch()

  const offerId = useWatch({ name: '_id' })
  const { useViewFileOnSharepoint } = useFile()
  const { data: sharepointTenderData, refetch, isLoading } = useViewFileOnSharepoint(offerId)
  const { tenderFolderLink, tenderQueriesFolderLink } = sharepointTenderData || {}

  return (
    <div>
      {label && (
        <FormLabel htmlFor={name} color={'black'} fontWeight={'semibold'}>
          <Flex gap={1}>
            <Box>{label} </Box>
          </Flex>
        </FormLabel>
      )}

      {/* show tender documents and link to folder */}
      {type == 'tenderFiles' && !isLoading && (
        <Box>
          {tenderFolderLink?.webUrl ? (
            <Link href={tenderFolderLink.webUrl} textDecor={'underline'} color="blue.400" target={'_blank'}>
              Link to Sharepoint
            </Link>
          ) : (
            <Text>No link available</Text>
          )}
        </Box>
      )}

      {/* show tender queries  */}
      {type == 'tenderQueries' && !isLoading && (
        <Box>
          {tenderQueriesFolderLink?.webUrl ? (
            <Link href={tenderQueriesFolderLink.webUrl} textDecor={'underline'} color="blue.400" target={'_blank'}>
              Link to Sharepoint
            </Link>
          ) : (
            <Text>No link available</Text>
          )}
        </Box>
      )}
    </div>
  )
}

export default SharepointFileList
